export type NotificationRouteRole = 'management' | 'subcontractor' | 'client';

export interface NotificationRouteLike {
  project_id?: string | null;
  notification_type?: string | null;
  link_path?: string | null;
  target_type?: string | null;
  related_table?: string | null;
}

function getNotificationTab(notification: NotificationRouteLike, role: NotificationRouteRole): string | null {
  const key = [
    notification.notification_type,
    notification.target_type,
    notification.related_table,
    notification.link_path,
  ]
    .filter(Boolean)
    .join(' ')
    .toLowerCase();

  if (key.includes('change_order') || key.includes('change-orders') || key.includes('change order')) return 'Change Orders';
  if (key.includes('instruction')) return role === 'management' ? 'Instructions' : role === 'client' ? 'Change Orders' : null;
  if (key.includes('schedule')) return 'Schedule';
  if (key.includes('checklist')) return 'Checklist';
  if (key.includes('daily') || key.includes('log')) return 'Daily Log';
  if (key.includes('photo') || key.includes('update')) return role === 'management' ? 'Photos' : null;
  if (key.includes('file')) return 'Files';
  if (key.includes('task')) return role === 'management' ? 'Tasks' : null;
  if (key.includes('payment')) return role === 'management' ? 'Payments' : null;
  if (key.includes('question')) return role === 'management' ? 'Questions' : null;

  return null;
}

function withTab(path: string, tab: string | null): string {
  if (!tab) return path;
  const separator = path.includes('?') ? '&' : '?';
  return `${path}${separator}tab=${encodeURIComponent(tab)}`;
}

export function resolveNotificationRoute(
  notification: NotificationRouteLike,
  role: NotificationRouteRole
): string | null {
  const projectId = notification.project_id;
  const tab = getNotificationTab(notification, role);

  if (projectId) {
    if (role === 'management') return withTab(`/management/projects/${projectId}`, tab);
    if (role === 'subcontractor') return withTab(`/subcontractor/project/${projectId}`, tab);
    return withTab(`/client/portal?projectId=${encodeURIComponent(projectId)}`, tab);
  }

  return notification.link_path || null;
}
